// extracted by mini-css-extract-plugin
export var formLink = "FormLink-module--formLink--afc6f";
export var wrapper = "FormLink-module--wrapper--7a218";